// Prefixed OpenFGA principal vocabulary, shared across resources (agents,
// projects, …). A principal is either an individual user (`user:{email}`) or a
// group/user-tag (`user-tag:{tag}`) whose members inherit access.

const USER_PRINCIPAL_PREFIX = "user:";
const GROUP_PRINCIPAL_PREFIX = "user-tag:";

/** Prefixed OpenFGA principal for an individual user. */
export const userPrincipal = (email: string) => `${USER_PRINCIPAL_PREFIX}${email}`;
/** Prefixed OpenFGA principal for a group (user-tag). */
export const groupPrincipal = (tag: string) => `${GROUP_PRINCIPAL_PREFIX}${tag}`;

// The typed wildcard ("everyone"): a `user:*` principal granting access to every
// user. Modeled as a user whose bare id is `*`, so it flows through the same
// `userPrincipal` send path. Valid at the lowest access level only.
export const EVERYONE_ID = "*";
/** UI name for the wildcard. Deliberately vague: it reaches every signed-in user
 * of this deployment, so it is neither "the organization" nor "the public". */
export const EVERYONE_LABEL = "Everyone";
/** True when a bare principal id (from `parsePrincipal`) is the everyone wildcard. */
export const isEveryoneId = (id: string) => id === EVERYONE_ID;

/** Split a prefixed principal into its kind and bare id (email or tag). The
 * group prefix is checked first since `user-tag:` also starts with `user`. */
export const parsePrincipal = (principal: string): { isGroup: boolean; id: string } => {
  if (principal.startsWith(GROUP_PRINCIPAL_PREFIX)) {
    return { isGroup: true, id: principal.slice(GROUP_PRINCIPAL_PREFIX.length) };
  }
  return { isGroup: false, id: principal.slice(USER_PRINCIPAL_PREFIX.length) };
};
